import React from "react";
import { css, cx } from "styled-system/css";
import type { SystemStyleObject } from "styled-system/types";
import { button } from "./button.styles";

type ButtonVariant = "primary" | "secondary" | "outline" | "ghost" | "danger";
type ButtonSize = "small" | "medium" | "large";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
  css?: SystemStyleObject;
  as?: undefined;
}

interface AnchorButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
  css?: SystemStyleObject;
  as: "a";
}

export function Button(props: ButtonProps): React.ReactElement;
export function Button(props: AnchorButtonProps): React.ReactElement;

export function Button({
  variant: variantProp = "primary",
  size: sizeProp = "medium",
  fullWidth: fw = false,
  className: classNameProp,
  css: cssProp,
  as,
  ...props
}: ButtonProps | AnchorButtonProps): React.ReactElement {
  const generatedClassName = cx(button({ variant: variantProp, size: sizeProp, fullWidth: fw }), cssProp && css(cssProp));

  const classes = classNameProp ? `${generatedClassName} ${classNameProp}` : generatedClassName;

  if (as === "a") {
    const { as: _, ...anchorProps } = props as AnchorButtonProps;
    return <a className={classes} {...anchorProps} />;
  }

  const { as: _, ...buttonProps } = props as ButtonProps;
  return <button className={classes} {...buttonProps} />;
}
